import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SiteApp } from './SiteApp';
import './site.css';

const el = document.getElementById('rewardify-site');

if (el) {
  createRoot(el).render(
    <StrictMode>
      <SiteApp />
    </StrictMode>,
  );
}
